import { mapActions, mapState } from 'vuex'

export const mixinPtoProjectSelect = {
  computed: {
    ...mapState('handbook/pto', {
      buildingList: 'buildingList',
      objectList: 'objectList',
      statusProjectList: 'statusProjectList',
      handbookIDList: 'handbookIDList',
      productTypeList: 'productTypeList'
    }),
    ...mapState('handbook/contracts', {
      contractsList: 'contractsList'
    })
  },
  methods: {
    ...mapActions('handbook/pto', {
      GETBuildingList: 'GETBuildingList',
      GETObjectList: 'GETObjectList',
      GETStatusProjectList: 'GETStatusProjectList',
      GETHandbookIDList: 'GETHandbookIDList',
      GETProductTypeList: 'GETProductTypeList'
    }),
    ...mapActions({
      GETContractsList: 'handbook/contracts/GETContractsList'
    })
  }
}
